export default "__VITE_ASSET__fbb93dd9__"